import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { getRemoteConfig } from "firebase/remote-config";
import { ETokenType } from "../enums";
import { updateUserToken } from "../setup/api/services/user";
import { AuthConfig } from "../setup/context/config/authConfig";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export type RemoteConfig = {
  _source: string;
  _value: string;
};

const app = initializeApp(firebaseConfig);
export const remoteConfig = getRemoteConfig(app);
// TODO: Uncomment the following line to remove caching and fetch remote configs real time or use polling
// Set fetch interval to 0 to fetch fresh values every time
remoteConfig.settings.minimumFetchIntervalMillis = 0;

export const requestFireBaseToken = async (): Promise<string | void> => {
  const messagingSupported = await isSupported();
  if (!messagingSupported) {
    console.warn("Messaging is not supported.");
    return;
  }

  try {
    const registration = await navigator?.serviceWorker?.ready;
    console.log("registration", registration);
    const messaging = getMessaging(app);
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPI_KEY,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      const userId = AuthConfig?.getUserInfo()?.id;
      await updateUserToken(userId, {
        token: currentToken,
        tokenType: ETokenType.FCM,
      });
      return currentToken;
    } else {
      throw new Error(
        "No registration token available. Request permission to generate one."
      );
    }
  } catch (err: any) {
    if (
      err.code === "messaging/permission-blocked" ||
      err.code === "messaging/permission-default"
    ) {
      console.warn("Notification permission was not granted:", err);
    } else {
      console.error("An error occurred while retrieving token:", err);
      throw err;
    }
  }
};

export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Registration successful, scope is:", registration?.scope);
      })
      .catch((err) => {
        console.error("Service worker registration failed, error:", err);
      });
  } else {
    console.warn("Service worker is not supported in this browser.");
  }
};
